// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/layoutEdit/selectable/selectable.js#1 $
'use strict';

angular.module('tcApp').directive('tcSelectable', function() {
	return {
		restrict: 'AE',
		transclude: true,
		replace: true,
		scope: {
			'tcIndex': '=',
			'tcType': '@',
			'tcToolbox': '@',
			'tcArray': '=',
			'tcState': '=',
			'toggleOptionsHover': '&',
			'openOptionsPanel': '&',
			'tcAfterDrop': '&',
			'tcAllowSelect': '&'
		},
		templateUrl: 'template/layoutEdit/selectable/selectable.html',
		link: function(scope, element) {
			
			// Finds the maximum level of blocks within the container recursively
			var getBlockLevel = function(container) {
				var blockLevels = [0];
				angular.forEach(container.rows, function(row) {
					angular.forEach(row.blocks, function(block) {
						blockLevels.push(getBlockLevel(block) + 1);
					});
				});
				return Math.max.apply(null, blockLevels);
			};
			
			scope.select = function($event) {
				var item = scope.tcArray[scope.tcIndex];
				
				if (scope.tcAllowSelect(item) === false) return;
				
				// Allow selecting a layout element and adding multiple items from the toolbox
				if (scope.tcState.selected.array &&
					!scope.tcState.selected.isToolbox &&
					scope.tcToolbox) {
					if ((',' + scope.tcState.selected.type + ',').indexOf((',' + scope.tcType + ',')) === -1) {
						return;
					}
					
					item = angular.copy(item);
					if ((scope.tcState.selected.type.indexOf('row') !== -1)
						&& (angular.isUndefined(item.itemRefs))) {
						item = {itemRefs: [item]};
					}
					if (scope.tcState.selected.type.indexOf('column') !== -1) {
						item = {columnRows: [{tableItemRefs: [item]}]};
					}
					scope.tcState.selected.array.splice(scope.tcState.selected.index + 1, 0, item);
					scope.tcState.selected.array[scope.tcState.selected.index].selected = false;
					scope.tcState.selected.array[scope.tcState.selected.index + 1].selected = true;
					scope.tcState.selected.index = scope.tcState.selected.index + 1;
					scope.toggleOptionsHover();
					scope.tcAfterDrop();
					return;
				}
				item.selected = !item.selected;
				if (item.selected) {
					scope.deselect($event);
					scope.tcState.selected.array = scope.tcArray;
					scope.tcState.selected.index = scope.tcIndex;
					scope.tcState.selected.type = scope.tcType;
					scope.tcState.selected.isToolbox = scope.tcToolbox;
					scope.tcState.selected.blockLevel = getBlockLevel(scope.tcArray[scope.tcIndex]);
				} else {
					scope.tcState.selected = {};
				}
				scope.toggleOptionsHover({$event: $event});
				$event.stopPropagation();
			};
			scope.deselect = function($event) {
				if (scope.tcState.selected.array) {
					scope.tcState.selected.array[scope.tcState.selected.index].selected = false;
				}
				scope.tcState.selected = {};
				scope.toggleOptionsHover({$event: $event});
			};
			
			// Opens the item/element options when item is double-clicked
			scope.openOptions = function($event) {
				$event.stopPropagation();
				if (scope.tcToolbox) return;
				var item = scope.tcArray[scope.tcIndex];
				if (scope.tcAllowSelect(item) === false) return;
				
				scope.openOptionsPanel({$event: $event,
					optionsPanelMode: scope.tcType,
					optionsPanelItem: item
				});
			};

			var onDragstart = function($event) {
				$event.dataTransfer.effectAllowed = 'move';
				$event.stopPropagation();
				scope.$apply(function() {
					scope.deselect($event);
					scope.select($event);
				});
			};
			element.on('dragstart', onDragstart);

			var onDragend = function($event) {
				$event.stopPropagation();
				scope.$apply(scope.deselect($event));
			};
			element.on('dragend', onDragend);

			element.attr('draggable', 'true');

		}
	};
});
